import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';
// import history from '../../history';
import UserValidation from './Validation';
import {Translate, I18n} from 'react-redux-i18n';

import {
  saveUser as saveUserAction,
  deleteUser as deleteUserAction,
  changeForm as changeFormAction,
  setError as setErrorAction,
  fetchUser as fetchUserAction
} from './UserActions';
import style from './User.module.css';
import helpers from '../../helpers';

function User(props) {
  const { 
    userId, 
    companies, 
    errors, 
    user: userData, 
    fetchUser, 
    saveUser, 
    deleteUser: deleteUserProp, 
    changeForm, 
    setError, 
    isEdit 
  } = props;
  
  const navigate = useNavigate();

  useEffect(() => {
    if (userId) {
      fetchUser(userId);
    }
  }, [userId, fetchUser]);

  function onSave(e) {
    e.preventDefault();

    const { user: userProp } = props;

    const validationResult = validateUser();

    setError(validationResult);
    const hasError = Object.keys(validationResult).length > 0;

    if (!hasError) {
      saveUser(userProp, userId).then(() => {
          navigate(-1);
      });
    }
  }

  function deleteUser(e) {
    e.preventDefault();

    if (window.confirm('Are you sure you want to delete this user?')) {
      deleteUserProp(userId).then(() => {
          navigate('/users');
      });
    }
  }

  function validateUser() {
    const { user: userProp } = props;
    const currentUser = helpers.getUserFromLocalStorage();

    const isMaster = currentUser.level === 'master';

    return UserValidation(userProp, isEdit, isMaster);
  }

  function changeField(e) {
    e.preventDefault();

    const { id, value } = e.target;

    changeForm(id, value);
  }

  function error(err) {
    return <div className="text-danger">{err}</div>;
  }

  function goBack(e) {
    e.preventDefault();
    navigate(-1);
  }

  const { user, name, password, passwordRepeat, level, company } = userData;

  const currentUser = helpers.getUserFromLocalStorage();
  const isMyself = userId === currentUser._id;
  const isAdmin = currentUser.level === 'admin';
  const isMaster = currentUser.level === 'master';
  const isShared = currentUser.level === 'shared';

  return (
    <form>
      { errors.general && <div className="alert alert-danger">{errors.general}</div> }
      {!isShared &&
        <div className={`mb-3 ${errors.user && 'has-error'}`}>
          <label className="control-label" htmlFor="user"><Translate value="user.User"/></label>
          <input
            type="text"
            className="form-control"
            id="user"
            value={user || ''}
            onChange={changeField}
          />
          { errors.user && error(errors.user) }
        </div>
      }
      {!isShared &&
        <div className={`mb-3 ${(errors.name && 'has-error') || ''}`}>
          <label className="control-label" htmlFor="name"><Translate value="user.Name"/></label>
          <input
            type="text"
            className="form-control"
            id="name"
            value={name || ''}
            onChange={changeField}
          />
          { errors.name && error(errors.name) }
        </div>
      }
      {!isShared &&
        <div className={`mb-3 ${errors.password && 'has-error'}`}>
          <label className="control-label" htmlFor="password"><Translate value="user.Password"/></label>
          <input
            type="password"
            className="form-control"
            id="password"
            value={password || ''}
            onChange={changeField}
          />
          { errors.password && error(errors.password) }
        </div>
      }
      {!isShared &&
        <div className={`mb-3 ${errors.passwordRepeat && 'has-error'}`}>
          <label className="control-label" htmlFor="password"><Translate value="user.RepeatPsw"/></label>
          <input
            type="password"
            className="form-control"
            id="passwordRepeat"
            value={passwordRepeat || ''}
            onChange={changeField}
          />
          { errors.passwordRepeat && error(errors.passwordRepeat) }
        </div>
      }
      { (isMaster || isAdmin) &&
        <div className={`mb-3 ${errors.level && 'has-error'}`}>
          <label className="control-label" htmlFor="level"><Translate value="user.UserLevel"/>:</label>
          <select
            className="form-control"
            id="level"
            value={level || ''}
            onChange={changeField}
          >
            {isMaster && <option value="master">{I18n.t("user.level.Master")}</option>}
            <option value="admin">{I18n.t("user.level.Admin")}</option>
            <option value="organizer">{I18n.t("user.level.Organiser")}</option>
            <option value="shared">{I18n.t("user.level.Shared")}</option>
          </select>
          { errors.level && error(errors.level) }
        </div>
      }
      { isMaster &&
        <div className={`mb-3 ${errors.company && 'has-error'}`}>
          <label className="control-label" htmlFor="level"><Translate value="user.Company"/>:</label>
          <select
            className="form-control"
            id="company"
            value={company || ''}
            onChange={changeField}
          >
            <option value="" disabled>{I18n.t("user.SelectCompany")}</option>
            {
              companies.map(comp => <option
                key={comp._id}
                value={comp._id}
              >{comp.name}</option>)
            }
          </select>
          { errors.company && error(errors.company) }
        </div>
      }

      <button className="btn btn-primary" onClick={onSave}>
        <i className="fas fa-check" /> <Translate value="controls.Save"/>
      </button>
      <button className={`btn btn-default ${style.btnMargin}`} onClick={goBack} >
        <i className="fas fa-mail-reply" /> <Translate value="controls.Back"/>
      </button>
      {
        !isMyself &&
        <button className="btn btn-danger float-end" onClick={deleteUser}>
          <i className="fas fa-times" /> <Translate value="controls.Delete"/>
        </button>
      }
    </form>
  );
}

User.propTypes = {
  user: PropTypes.object,
  userId: PropTypes.string,
  errors: PropTypes.object,
  isEdit: PropTypes.bool,
  companies: PropTypes.array,
  saveUser: PropTypes.func,
  changeForm: PropTypes.func,
  setError: PropTypes.func,
  deleteUser: PropTypes.func,
  fetchUser: PropTypes.func,
};

const mapStateToProps = state => ({
  user: state.user.data,
  isEdit: state.user.isEdit,
  errors: state.user.errors,
  companies: state.user.companies,
});

const mapDispatchToProps = {
  fetchUser: fetchUserAction,
  saveUser: saveUserAction,
  deleteUser: deleteUserAction,
  changeForm: changeFormAction,
  setError: setErrorAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(User);
